import { useEffect } from 'react';

/*
 * 영문 홈페이지 공통 (2026-11-04).
 * 주소는 /en · /en/bus · /en/introduce · /en/center. 네이버·구글 로봇에게는 nginx 가
 * prerender/ 의 정적 HTML(같은 글)을 준다 — 여기 글을 고치면 prerender/build_prerender.py 의 영어 글도 같이 고친다.
 */

/** 영문 주소인가 (/en, /en/…) */
export const isEnglishPath = (pathname) => pathname === '/en' || pathname.startsWith('/en/');

/** 영어 상호. 법인명은 주식회사 이케이투어(EK Tour Co., Ltd.) — 비버 영문 견적서와 같다 */
export const BRAND = 'EK Hana Tour';
export const COMPANY = 'EK Tour Co., Ltd.';

/** 한국 번호(02-123-4567, 010-1234-5678)를 해외에서 거는 꼴(+82 2-123-4567)로 */
export function intlPhone(kor) {
  const v = String(kor || '').trim();
  if (!v) return '';
  return v.startsWith('0') ? `+82 ${v.slice(1)}` : v;
}

/**
 * 탭 제목·설명·주소 표시를 영어 페이지에 맞춘다. 한국어 페이지로 돌아가면 LangSync 가 lang 을 되돌린다.
 * 첫 HTML 의 머리(index.html)는 한국어라, 자바스크립트를 돌리는 구글은 이 값을 읽는다.
 */
export function useEnglishPage(title, description) {
  useEffect(() => {
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    const before = desc ? desc.getAttribute('content') : null;
    if (desc) desc.setAttribute('content', description);
    return () => {
      if (desc && before != null) desc.setAttribute('content', before);
    };
  }, [title, description]);
}

export const orange = '#EC9F46';
export const brown = '#5A4231';
